import React, { Component } from "react";
import { BiArrowBack } from "react-icons/bi";
import SurveyQuizUI from "./TriviaQuizUI";

export default class PreviewQuizPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      surveyId: null,
      orgId: null,
    };
  }

  componentDidMount() {
    const surveyId = this.props.match.params.surveyId;
    const orgId = this.props.match.params.orgId;
    this.setState({ surveyId: surveyId, orgId });
    window.addEventListener('popstate', this.handlePopState);
    this.setState({ surveyId: surveyId });
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  handlePopState = (e) => {
     e.preventDefault();
      window.history.forward();
  };

  togglePreview = () => {
    this.props.history.push(
      `/home/trivia/${this.state.orgId}/edit/${this.state.surveyId}/edit`
    );
  };

  render() {
    return (
      <div>
        {this.state.surveyId && (
          <SurveyQuizUI
            surveyId={this.state.surveyId}
            {...this.props}
            previewOnly
            togglePreview={this.togglePreview}
          />
        )}
      </div>
    );
  }
}
